<nav class="navigation">
    <wuc-navigation>
        <wuc-navigation-item
            name="Home"
            icon="house"
            [url]="baseUrl"
        ></wuc-navigation-item>
        <wuc-navigation-item name="Verzekeringen" width="full" e2e="menu-main-verzekeringen">
            <div class="navigation__dropdown navigation__dropdown--split">
                <div class="navigation__dropdown-left">
                    <div class="h3 navigation__title">Onze schadeverzekeringen</div>
                    <wuc-rack columnsDesktop="3" gridGap="large">
                        <div>
                            <p class="navigation__subtitle">Op de weg</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.CarInsurance"
                                        linkTitle="Autoverzekering"
                                    >
                                        Autoverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.MopedInsurance"
                                        linkTitle="Brommerverzekering"
                                    >
                                        Brommerverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.ScooterInsurance"
                                        linkTitle="Scooterverzekering"
                                    >
                                        Scooterverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.MotorInsurance)"
                                        [url]="generateUrl(appRoutesEnum.MotorInsurance)"
                                        linkTitle="Motorverzekering"
                                    >
                                        Motorverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.BicycleInsurance"
                                        linkTitle="Fietsverzekering"
                                    >
                                        Fietsverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.CaravanInsurance)"
                                        [url]="generateUrl(appRoutesEnum.CaravanInsurance)"
                                        linkTitle="Caravanverzekering"
                                    >
                                        Caravanverzekering
                                    </wuc-link>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                        <div>
                            <p class="navigation__subtitle">In en om uw huis</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.InventoryInsurance"
                                        linkTitle="Inboedelverzekering"
                                    >
                                        Inboedelverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.BuildingInsurance"
                                        linkTitle="Opstalverzekering"
                                    >
                                        Opstalverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.HomeInsurance"
                                        linkTitle="Woonverzekering"
                                    >
                                        Woonverzekering
                                    </wuc-link>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                        <div>
                            <p class="navigation__subtitle">Persoonlijk &amp; gezin</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.TravelInsurance)"
                                        [url]="generateUrl(appRoutesEnum.TravelInsurance)"
                                        linkTitle="Reisverzekering"
                                    >
                                        Reisverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.LegalInsurance)"
                                        [url]="generateUrl(appRoutesEnum.LegalInsurance)"
                                        linkTitle="Rechtsbijstandverzekering"
                                    >
                                        Rechtsbijstandverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.LiabilityInsurance)"
                                        [url]="generateUrl(appRoutesEnum.LiabilityInsurance)"
                                        linkTitle="Aansprakelijkheidsverzekering"
                                    >
                                        Aansprakelijkheidsverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.AccidentInsurance)"
                                        [url]="generateUrl(appRoutesEnum.AccidentInsurance)"
                                        linkTitle="Ongevallenverzekering"
                                    >
                                        Ongevallenverzekering
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.PetInsurance)"
                                        [url]="generateUrl(appRoutesEnum.PetInsurance)"
                                        linkTitle="Dierenverzekering"
                                    >
                                        Dierenverzekering
                                    </wuc-link>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                    </wuc-rack>
                </div>
                <div class="navigation__dropdown-right">
                    <p class="navigation__subtitle">Meteen naar</p>
                    <wuc-list [lined]="true" lineColor="dark">
                        <wuc-list-item>
                            <wuc-link
                                type="tertiary"
                                target="_self"
                                [url]="baseUrl + '/' + appRoutesEnum.Insurances"
                                linkTitle="Alle verzekeringen"
                                [isRouterLinkActiveExact]="true"
                            >
                                Alle verzekeringen
                            </wuc-link>
                        </wuc-list-item>
                        <wuc-list-item>
                            <wuc-link
                                type="tertiary"
                                target="_self"
                                [route]="generateRoute(appRoutesEnum.SwitchService)"
                                [url]="generateUrl(appRoutesEnum.SwitchService)"
                                linkTitle="Overstaphulp"
                            >
                                Overstaphulp
                            </wuc-link>
                        </wuc-list-item>
                        <wuc-list-item>
                            <wuc-link
                                type="tertiary"
                                target="_self"
                                [route]="generateRoute(appRoutesEnum.Insurances + '/' + appRoutesEnum.CancelInsurance)"
                                [url]="generateUrl(appRoutesEnum.Insurances + '/' + appRoutesEnum.CancelInsurance)"
                                linkTitle="Wijzigen &amp; Opzeggen"
                            >
                                Wijzigen &amp; Opzeggen
                            </wuc-link>
                        </wuc-list-item>
                        <wuc-list-item>
                            <wuc-link
                                type="tertiary"
                                target="_self"
                                [url]="baseUrl + '/' + appRoutesEnum.About + '/' + appRoutesEnum.EverythingOnline + '/' + appRoutesEnum.PayPremium"
                                linkTitle="Premie betalen"
                            >
                                Premie betalen
                            </wuc-link>
                        </wuc-list-item>
                    </wuc-list>
                </div>
            </div>
        </wuc-navigation-item>
        <wuc-navigation-item name="Over InShared">
            <div class="navigation__dropdown">
                <wuc-list [lined]="true">
                    <wuc-list-item>
                        <wuc-link
                            type="tertiary"
                            target="_self"
                            [url]="baseUrl + '/' + appRoutesEnum.OurBenefits"
                            linkTitle="Onze benefits"
                            [isRouterLinkActiveExact]="true"
                        >
                            Onze benefits
                        </wuc-link>
                    </wuc-list-item>
                    <wuc-list-item>
                        <wuc-link
                            type="tertiary"
                            target="_self"
                            [url]="baseUrl + '/' + appRoutesEnum.About +'/' + appRoutesEnum.EverythingOnline"
                            linkTitle="Het gemak van alles online"
                            [isRouterLinkActiveExact]="true"
                        >
                            Het gemak van alles online
                        </wuc-link>
                    </wuc-list-item>
                    <wuc-list-item>
                        <wuc-link
                            type="tertiary"
                            target="_self"
                            [url]="baseUrl + '/' + appRoutesEnum.CustomerSatisfaction"
                            linkTitle="Hoe tevreden zijn klanten?"
                        >
                            Hoe tevreden zijn klanten?
                        </wuc-link>
                    </wuc-list-item>
                    <wuc-list-item>
                        <wuc-link
                            [routeFragment]="'klachten'"
                            type="tertiary"
                            target="_self"
                            [url]="baseUrl + '/' + appRoutesEnum.About +'#klachten'"
                            linkTitle="Niet tevreden?"
                        >
                            Niet tevreden?
                        </wuc-link>
                    </wuc-list-item>
                    <wuc-list-item>
                        <wuc-link
                            type="tertiary"
                            target="_self"
                            [route]="generateRoute(appRoutesEnum.Contact + '/' + appRoutesEnum.Reviews)"
                            [url]="generateUrl(appRoutesEnum.Contact + '/' + appRoutesEnum.Reviews)"
                            linkTitle="Reviews"
                        >
                            Reviews
                        </wuc-link>
                    </wuc-list-item>
                    <wuc-list-item>
                        <wuc-link type="tertiary" [rel]="rel" [url]="externalRoutesEnum.Jobs" linkTitle="Werken bij">
                            Werken bij
                        </wuc-link>
                    </wuc-list-item>
                </wuc-list>
            </div>
        </wuc-navigation-item>
        <wuc-navigation-item name="Schade" width="large">
            <div class="navigation__dropdown">
                <wuc-rack gridGap="large">
                    <wuc-rack columnsDesktop="2" gridGap="large">
                        <div>
                            <p class="navigation__subtitle">Nood of pech onderweg</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <p>
                                        Bij noodsituaties, zoals diefstal van auto, woninginbraak, letsel of grote
                                        lekkage bel:
                                    </p>
                                    <wuc-link
                                        type="tertiary"
                                        [url]="'tel:' + phoneNumbersEnum.EurocrossURL"
                                        [openUrlInNewTab]="false"
                                        iconLeft="call"
                                        iconSize="xs"
                                        [linkTitle]="'Bel: ' + phoneNumbersEnum.Eurocross"
                                    >
                                        <b>{{ phoneNumbersEnum.Eurocross }}</b>
                                    </wuc-link>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                        <div>
                            <p class="navigation__subtitle">Alles over schade</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        [openUrlInNewTab]="false"
                                        target="_self"
                                        [route]="generateRoute(appRoutesEnum.Damage)"
                                        [url]="generateUrl(appRoutesEnum.Damage)"
                                        linkTitle="Help ik heb schade!"
                                    >
                                        Help ik heb schade!
                                    </wuc-link>
                                </wuc-list-item>
                                <wuc-list-item>
                                    <wuc-link
                                        type="tertiary"
                                        [openUrlInNewTab]="false"
                                        target="_self"
                                        [url]="baseUrl + '/' + appRoutesEnum.AnnualReward + '/' + appRoutesEnum.AnnualRewardMostRecent"
                                        linkTitle="Schadeverslag"
                                    >
                                        Schadeverslag
                                    </wuc-link>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                    </wuc-rack>
                    <wuc-rack columnsDesktop="2" gridGap="large">
                        <div>
                            <p class="navigation__subtitle">Geen nood</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <p>Schade, declaratie huisdier, juridisch conflict of reismelding?</p>
                                    <wuc-button
                                        type="secondary"
                                        iconLeft="emergency"
                                        iconType="primary"
                                        title="Meld schade online"
                                        ins-authorize-before-redirect
                                        [url]="appRoutesEnum.OldClaimFunnel.replace('/', '')"
                                    >
                                        Meld schade online
                                    </wuc-button>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                        <div>
                            <p class="navigation__subtitle">Al schade gemeld?</p>
                            <wuc-list [lined]="true">
                                <wuc-list-item>
                                    <p>Bekijk hier de status van uw lopende schade.</p>
                                    <wuc-button
                                        type="secondary"
                                        iconLeft="damage-status"
                                        iconType="primary"
                                        title="Bekijk schadestatus"
                                        (buttonClick)="
                                            nativeRouterService.navigateByUrl(
                                                baseUrl + '/' + appRoutesEnum.MyZone + '/' + appRoutesEnum.MyClaims
                                            )
                                        "
                                    >
                                        Bekijk schadestatus
                                    </wuc-button>
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                    </wuc-rack>
                </wuc-rack>
            </div>
        </wuc-navigation-item>
        <wuc-navigation-item name="Slimme tips" [url]="baseUrl + '/' + appRoutesEnum.SmartTips" />
        <wuc-navigation-item
            name="Contact"
            [url]="'/' + appRoutesEnum.Contact"
        ></wuc-navigation-item>
    </wuc-navigation>
</nav>
